import { render, staticRenderFns } from "./CarouselItemList.vue?vue&type=template&id=08e2fae4&scoped=true"
import script from "./CarouselItemList.vue?vue&type=script&lang=js"
export * from "./CarouselItemList.vue?vue&type=script&lang=js"
import style0 from "./CarouselItemList.vue?vue&type=style&index=0&id=08e2fae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2fae4",
  null
  
)

export default component.exports